<script setup lang="ts"></script>

<template>
  <icon name="svg-spinners:ring-resize" class="text-primary" />
</template>

<style scoped></style>
